import initialState from '../store/initial-state'
import { ASSET_RIGHTS_STATE_UPDATED } from '../constants/rights-constants'
import {
  ASSET_ROOT_GET_DATA,
  ASSET_ROOT_GET_DATA_SUCCESS,
  ASSET_ROOT_GET_DATA_FAILURE,
  ASSET_ROOT_EMPTY,
  ASSET_ROOT_ACTIVEVIEW,
  ASSET_ROOT_EDIT,
  ASSET_ROOT_EDIT_SUCCESS,
  ASSET_ROOT_EDIT_FAILURE,
  ASSET_ROOT_DELETE,
  ASSET_ROOT_DELETE_SUCCESS,
  ASSET_ROOT_DELETE_FAILURE,
  ASSET_ROOT_EDIT_SELECT,
  ASSET_ROOT_EDIT_UNSET_SELECT,
  ASSET_ROOT_SHARE_SELECT,
  ASSET_ROOT_SHARE_UNSET_SELECT,
  ASSET_ROOT_CHECK_SELECT,
  ASSET_ROOT_UNCHECK_SELECT,
  MULTIPLE_ROOT_OPTIONS_ACTIVATE,
  MULTIPLE_ROOT_OPTIONS_DEACTIVATE,
  MULTIPLE_ROOT_OPTIONS_DONE,
  ASSET_ROOT_UPDATE_FROM_PERMISSION,
  ASSETS_ROOT_MULTI_DELETE,
  ASSETS_ROOT_MULTI_DELETE_SUCCESS,
  ASSETS_ROOT_MULTI_DELETE_FAILURE,
  ASSETS_ROOT_MULTI_MOVE,
  ASSETS_ROOT_MULTI_MOVE_SUCCESS,
  ASSETS_ROOT_MULTI_MOVE_FAILURE,
  CLEAN_DATA_BACK_ROOT,
  SCROLL_ROOT
} from '../constants/assets-root-types'

export default (state = initialState.assetsRoot, action) => {
  switch (action.type) {
    case ASSET_ROOT_GET_DATA:
      return {
        ...state,
        isFetching: action.payload.isFetching,
        data: action.payload.data,
        isLoadingScroll: action.payload.isLoadingScroll,
        // isFetching: true,
        // data: [],
        headers: null,
        error: null
      }

    case ASSET_ROOT_GET_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.user.clientRole === 'admin' || action.payload.user.role === 'admin'
          ? [...state.data,...action.payload.data]
          : [...state.data,...action.payload.data.filter(r => r.group.length > 0)],
        headers: action.payload.headers,
        showScrolling:  false,
        folderselect: action.payload.folderselect,
        error: null,
        isLoadingScroll: false
      }

    case ASSET_ROOT_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: null,
        showScrolling:  false,
        error: action.payload
      }

    case ASSET_ROOT_EMPTY:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: null,
        error: null
      }

    case ASSET_ROOT_ACTIVEVIEW:
      return {
        ...state,
        activeView: action.payload.activeView
      }

    case ASSET_ROOT_EDIT:
      return {
        ...state,
        isUpdating: true,
        headers: null,
        error: null
      }

    case ASSET_ROOT_EDIT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            indice: r._id === action.payload.data._id
              ? action.payload.indice
              : null,
            from: r._id === action.payload.data._id
              ? action.payload.from
              : null,
            name: r._id === action.payload.data._id
              ? action.payload.data.name
              : r.name,
            metadata: {
              ...r.metadata,
              descriptiveTags: r._id === action.payload.data._id
                ? action.payload.data.metadata.descriptiveTags
                : r.metadata && r.metadata.descriptiveTags ? r.metadata.descriptiveTags :undefined,
              createdDate: r._id === action.payload.data._id
                ? action.payload.data.metadata.createDate
                : r.metadata && r.metadata.createDate ? r.metadata.createDate :undefined,
              dueDate: r._id === action.payload.data._id
                ? action.payload.data.metadata.dueDate
                : r.metadata && r.metadata.dueDate ? r.metadata.dueDate :undefined,
            }
          }
        })]
      }

    case ASSET_RIGHTS_STATE_UPDATED: {
      const hasAsset = state.data.some(r => r._id === action.payload.assetId)
      if (!hasAsset) return state
      return {
        ...state,
        data: state.data.map(r =>
          r._id === action.payload.assetId
            ? {
                ...r,
                rightsState: action.payload.rightsState,
                metadata: {
                  ...r.metadata,
                  rightsStatus: action.payload.rightsStatus,
                  dueDate: action.payload.dueDate,
                  createdDate: action.payload.createdDate,
                  // El contrato y la hora de asignación también: la bitácora se
                  // refresca con ellos cuando lo único que cambió fue el contrato.
                  licenseFile: action.payload.licenseFile,
                  rightsAssignedAt: action.payload.rightsAssignedAt
                }
              }
            : r
        )
      }
    }

    case ASSET_ROOT_EDIT_FAILURE:
      return {
        ...state,
        isUpdating: false,
        headers: null,
        error: action.payload
      }
    case ASSET_ROOT_EDIT_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: r._id === action.payload.data._id,
          }
        })],
        editAssetTab: action.payload.editAssetTab
      }

    case ASSET_ROOT_EDIT_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: false,
          }
        })]
      }


    case ASSET_ROOT_DELETE:
      return {
        ...state,
        isFetching: true
      }

    case ASSET_ROOT_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => r._id !== action.payload.id)],
        error: null
      }

    case ASSET_ROOT_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }

    case ASSET_ROOT_SHARE_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isShareSelected: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_ROOT_SHARE_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isShareSelected: false,
          }
        })]
      }

    case ASSET_ROOT_CHECK_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: r._id === action.payload._id ? r.isCheckMultiple = true : r.isCheckMultiple
          }
        })]
      }

    case ASSET_ROOT_UNCHECK_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: r._id === action.payload._id ? r.isCheckMultiple = false : r.isCheckMultiple
          }
        })]
      }

    case MULTIPLE_ROOT_OPTIONS_ACTIVATE:
      return {
        ...state,
        activateMultiOptions: true
      }
    case MULTIPLE_ROOT_OPTIONS_DEACTIVATE:
      return {
        ...state,
        activateMultiOptions: false
      }

    case MULTIPLE_ROOT_OPTIONS_DONE:
      return {
        ...state,
        activateMultiOptions: false,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: false
          }
        })]
      }

    case ASSET_ROOT_UPDATE_FROM_PERMISSION:
      return {
        ...state,
        data: [
          ...state.data.map(r => {
            return r._id === action.payload._id
              ? action.payload
              : { ...r }
          })
        ]
      }
    case ASSETS_ROOT_MULTI_DELETE:
      return {
        ...state,
        isFetching: true
      }

    case ASSETS_ROOT_MULTI_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => !action.payload.ids.includes(r._id))],
        error: null
      }

    case ASSETS_ROOT_MULTI_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }
    case ASSETS_ROOT_MULTI_MOVE:
      return {
        ...state,
        isMoving: true,
        headers: null,
        error: null
      }

    case ASSETS_ROOT_MULTI_MOVE_SUCCESS:
      return {
        ...state,
        isMoving: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            isMoveSelected: false,
            isMoved: action.payload.ids.includes(r._id),
          }
        })]
      }

    case ASSETS_ROOT_MULTI_MOVE_FAILURE:
      return {
        ...state,
        isMoving: false,
        headers: null,
        error: action.payload
      }
    case CLEAN_DATA_BACK_ROOT:
      return {
        ...state,
        data: [],
        pageScrolling: 1
      }
    case SCROLL_ROOT:
      return {
        ...state,
        showScrolling: action.payload.showScrolling,
        pageScrolling: action.payload.pageScrolling,
      }
    default: return { ...state }
  }
}
